module.exports = __webpack_public_path__ + "img/1.7e14ea02.jpg";